import React from 'react'
import styles from './Page.module.less'
import classnames from 'classnames'
import Loader from '../Loader/Loader'

const Page = (props) => {
    const { children,className, loading = false, inner = false,msgLoading="" } = props
    console.log(msgLoading);
    const loadingStyle = {
        height: 'calc(100vh - 184px)',
        overflow: 'hidden',
      }
    return (
        <div
            className={classnames(className, {
                [styles.contentInner]: inner,
            })}
            
            style={loading ? loadingStyle : null}
        >
            {loading ? <Loader spinning msgLoading={msgLoading} /> : ''}
            {children}
        </div>
    )
}

export default Page